<!-- 活动评选分析 -->
<template>
  <div class="activity-appraise">
    <div class="activity-appraise-title">
      <div class="name">活动评选分析</div>
      <!-- <div class="more">详情<i class="el-icon-arrow-right"></i></div> -->
    </div>
    <div class="activity-appraise-number">
      <div class="tips"></div>
      <div class="title">总活动（个）</div>
      <div class="number">{{hdpxNum}}</div>
    </div>
    <div class="activity-appraise-radar">
      <div class="chart" id="activityAppraiseIdId" ></div>
      <div class="chart-error" v-show="isShow">
          <div class="detail">
              <span class="detail">暂无数据</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPlatformActivityTypeStatAPI} from "@/service/api.js"
export default {
  name: 'activity-appraise',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    //区域平台类型
    regionType:{
      type:String,
      default:""
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    //学校id
    schoolId:{
      type:String,
      default:""
    },
    //活动评选数量
    hdpxNum:{
      type:Number,
      default:0
    }
  },
  watch:{
    startTime(){
      this.getPlatformActivityTypeStat();
    },
    endTime(){
      this.getPlatformActivityTypeStat();
    },
    schoolId(){
      this.getPlatformActivityTypeStat();
    },
    address(){
      this.getPlatformActivityTypeStat();
    }
  },
  data() {
      return {
        dataList:[],
        activityNumber:0
      }
  },
  methods: {
    /**
     * @name 初始化echarts图表
     */
    initEchart(){
      let _this=this;
      let indicatorList = []
      let valueList = []
      _this.dataList.forEach((item)=>{
        indicatorList.push({
          name:item.name,
          max:item.max,
          title:item.title
        })
        valueList.push(item.num)
      })
      let dataSource = _this.$echarts.init(
          document.getElementById('activityAppraiseIdId')
      );
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: params => {
            let name = ""
            for(let i = 0;i<valueList.length;i++){
              name = name + indicatorList[i].title + ":" + valueList[i] + "<br>";
            }
            return  "类型<br/>" + name ;
          }
        },
        legend: {
          show:false,
          data: ['类型'],
          textStyle: {
            color: "#333",
            fontSize: 14
          }
        },
        radar: {
          // 雷达图维度定义
          indicator:indicatorList,
          splitArea: {
            show: true,
            areaStyle: {
                color: ['transparent']
            }
          },
          center: ['50%', '50%'],
          radius:"60%"
        },
        series: [{
          name: '类型',
          type: 'radar',
          // 数据源
          data : [
            {
              value:valueList,
            }
          ],
          areaStyle: {
              color: '#817531' // 设置包裹区域颜色
          },
          itemStyle:{
            normal:{
              lineStyle: {
                color: '#0CA1E1'  // 折线颜色
              },
              itemStyle:{
                color:"#FFDF25"
              }
            }
          }
        }]
      };
      dataSource.setOption(option);
      window.addEventListener("resize", function () {
          dataSource.resize();
      });
    },
    /**
     * @name 获取平台综合评审按类型统计
     */
    getPlatformActivityTypeStat(){
      let params = {
        regionId:this.regionId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        schoolId:this.schoolId,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformActivityTypeStatAPI(params).then((res)=>{
        let number = 0;
        res.forEach((item)=>{
          number = number+item.num
        })
        this.activityNumber = number;
        this.dataList = res.map((item)=>{
          let percentage = item.num ? ((item.num / number)*100).toFixed(2) : 0;
          return {
            name:`${item.title}\n ${percentage}%`,
            title:item.title,
            max:number,
            num:item.num
          }
        })
        this.initEchart();
      }).catch((err)=>{})
    }
  },
  mounted(){
    //获取平台综合评审按类型统计
    this.getPlatformActivityTypeStat();
  },
}
</script>

<style lang="scss" scoped>
.activity-appraise{
  // padding: 0 5px;
  margin-top: 25px;
  // height: 450px;
  width: 100%;
  // background: rgba(9,19,66,0.6);
  border: 1px solid #427CC2;
  border-radius: 0px 0px 4px 4px;
  .activity-appraise-title{
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    height: 40px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .more{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
    }
  }
  .activity-appraise-number{
    display: flex;
    align-items: center;
    margin-top:24px;
    margin-left: 18px;
    .tips{
      width: 10px;
      height: 10px;
      background: #FFDF25;
      border-radius: 50%;
      margin-right: 4px;
    }
    .title{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #C4D6F2;
      margin-right: 15px;
    }
    .number{
      font-size: 32px;
      font-family: MaravaleExpanded;
      font-weight: normal;
      color: #6FEFFF;
      @font-face {
        font-family: MaravaleExpanded;
        src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
      }
    }
  }
  .activity-appraise-radar{
    width: 100%;
    height: 400px;
    .chart{
      width: 100%;
      height: 100%;
    }
  }
}
</style>